import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/sections/Home/Home';
import WhyYouWillLoveIt from './components/sections/WhyYouWillLoveIt/WhyYouWillLoveIt';
import ThisIsYourMoment from './components/sections/ThisIsYourMoment/ThisIsYourMoment';
import DontMissOut from './components/sections/DontMissOut/DontMissOut';
import EmailModal from './components/EmailModal/EmailModal';
import VideoPage from './components/VideoPage/VideoPage';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={
            <>
              <Home onCtaClick={openModal} />
              <WhyYouWillLoveIt />
              <ThisIsYourMoment />
              <DontMissOut onSectionClick={openModal} />
              <EmailModal isOpen={isModalOpen} onClose={closeModal} />
            </>
          } />
          <Route path="/video" element={<VideoPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
